<!-- App.svelte -->
<script>
	import Router, { push } from 'svelte-spa-router';
	import Home from './Home.svelte';
	import AboutPage from './AboutPage.svelte';
	import LogInGreeting from './LogInGreeting.svelte';
	import RegisterForClass from './RegistrationForClass.svelte'
	import RegisterSuccess from './RegistrationSucess.svelte'
	import SchedulePage from './Schedule.svelte';
	import './styles/global.css';
	import ChangeClassPage from './ChangeClassTime.svelte';
	import CancelPage from './CancelClassPage.svelte';
	import ChangeSucess from './RescheduleSuccess.svelte'
	import LeaveCommentPage from './LeaveCommentPage.svelte'
	import '@fortawesome/fontawesome-free/css/all.min.css';
	import LeaveNoteSuccess from './LeaveNoteSuccess.svelte';
	import RescheduleRequestsPage from './RescheduleRequestsPage.svelte';
	import SettingsAndTimeslots from './SettingsAndTimeslotsPage.svelte';
	import InvoicesPage from './InvoicesPage.svelte';
	import StandaloneInvoicesPage from './StandaloneInvoicesPage.svelte';
	import AccountPage from './AccountPage.svelte';
	import TeacherRequestsPage from './TeacherRequestsPage.svelte';
	import AdminPage from './AdminPage.svelte';
	import UpdateCredentialsPage from './UpdateCredentialsPage.svelte';
    import RedirectAfterPaymentRoute from './RedirectAfterPaymentRoute.svelte';
	import AdminSearchPage from './AdminSearchPage.svelte';
	import ClassDidNotHappenComponent from './ClassDidNotHappenComponent.svelte';
	import AdminTeacherSurveilancePage from './AdminTeacherSurveilancePage.svelte';
	import ForgotPasswordPage from './forgot-password.svelte';
	import TeacherPerformancePage from './TeacherPerformancePage.svelte';
	import TeacherInvoicesPage from './TeacherInvoicesPage.svelte';
	import TeacherRegistrationPage from './TeacherRegistrationPage.svelte';
	import AdminStudentInvoiceViewer from './AdminStudentInvoiceViewer.svelte';
	import AdminStudentScheduleViewer from './AdminStudentScheduleViewer.svelte';
	import AdminUserInvoicePageViewer from './AdminUserInvoicePageViewer.svelte';
	import AdminStudentsPage from './AdminStudentsPage.svelte';
	import AdminTeachersPage from './AdminTeachersPage.svelte';
	import AdminAllDashboardPage from './AdminAllDashboardPage.svelte';
	import AdminActivityDashboardPage from './AdminActivityDashboardPage.svelte';
	import AdminCalendarPage from './AdminCalendarPage.svelte';
    import AdminMonthlyFeedbackPage from './AdminMonthlyFeedbackPage.svelte';
	import ExcerciseBankLandingPage from './Excercise_bank_landing_page.svelte';
	import UploadExercise from './Upload_excercise.svelte';
	import ExerciseBankPage from './ExerciseBankPage.svelte';
	import BendraInformacijaPage from './BendraInformacijaPage.svelte';
	import InvoiceOpenRoute from './InvoiceOpenRoute.svelte';
    import InboxPage from './inbox/InboxPage.svelte';
    import { conversationPath } from './inbox/navigation.js';
  
  
  
	const routes = {
		'/': AboutPage,
		'/about': AboutPage,
		'/forgot-password': ForgotPasswordPage,
		'/login-greeting': LogInGreeting,
		'/registration-for-class': RegisterForClass,
		'/register-success':RegisterSuccess,
		'/schedule':SchedulePage,
		'/class/:id': ChangeClassPage,
		'/class/cancel-class/:id':CancelPage,
		'/change-class-success': ChangeSucess,
		'/leave-comment/:id' : LeaveCommentPage,
		'/note-success':LeaveNoteSuccess,
		'/reschedule-requests': RescheduleRequestsPage,
		'/settingsAndTimeslots': SettingsAndTimeslots,
		'/invoice':StandaloneInvoicesPage,
		'/bendra-informacija': BendraInformacijaPage,
		'/account':AccountPage,
		'/teacher_requests':TeacherRequestsPage,
		'/admin':AdminPage,
		'/update-credentials':UpdateCredentialsPage,
		'/redirect-after-payment-route': RedirectAfterPaymentRoute,
		'/adminSearch' : AdminSearchPage,
		'/teacherSurveilance' : AdminTeacherSurveilancePage,
		'/teacher-performance': TeacherPerformancePage,
		'/teacher-invoices': TeacherInvoicesPage,
		'/teacher-registrations': TeacherRegistrationPage,
		'/admin/student-invoice-debug': AdminStudentInvoiceViewer,
		'/admin/student-schedule-debug': AdminStudentScheduleViewer,
		'/admin/user-invoice-view': AdminUserInvoicePageViewer,
		'/admin/students': AdminStudentsPage,
		'/admin/teachers': AdminTeachersPage,
		'/admin/all': AdminAllDashboardPage,
		'/admin/activity-dashboard': AdminActivityDashboardPage,
		'/admin/calendar': AdminCalendarPage,
        '/admin/monthly-feedback': AdminMonthlyFeedbackPage,
		'/exercise-bank': ExcerciseBankLandingPage,
		'/exercise-bank/upload': UploadExercise,
		'/exercise-bank/bank': ExerciseBankPage,
		'/invoice-open/:paymentId': InvoiceOpenRoute,
        '/inbox': InboxPage,
        '/inbox/:id': InboxPage,
  
	};

    function routeEvent(event) {
      if (event.type !== 'inbox-thread') return;
      const destination = conversationPath(event.id);
      if (destination && window.location.hash !== `#${destination}`) push(destination);
    }

  </script>
  <div class="background"></div>
  <style>
	@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;700&display=swap');

	:global(body) {
		font-family: 'Poppins', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
		}
	.background {
	  position: fixed;
	  top: 0;
	  left: 0;
	  width: 100%;
	  height: 100%;
	  z-index: -1;
	  background-color: #fffffa;
	  display: flex;
	  justify-content: center;
	  align-items: center;
	}
	main {
	  padding: 1rem;
	  max-width: 600px;
	  margin: 0 auto;
	}

	/* Full screen for exercise bank page */
	:global(main > :global(.app-container)) {
	  max-width: none;
	  margin: 0;
	  padding: 0;
	}

	:global(main:has(> .app-container)) {
	  padding: 0;
	  max-width: none;
	  margin: 0;
	}
  </style>

  <main>
	<Router {routes} onRouteEvent={routeEvent} />
  </main>
